import styled from "styled-components";

import { LARGE_SCREEN } from "../../constants/screenSizes";
import { typographyWeights } from "../constants/fontWeightOptions";
import { baseTextStyles } from "../shared/styled";

export const PrimaryMediumBase = styled.h2`
  ${baseTextStyles}
  font-size: 32px;
  font-weight: ${props => typographyWeights[props.weight]};
  line-height: 40px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 28px;
    line-height: 36px;
  }
`;
